import _ from 'lodash';
import {connect} from 'react-redux';

import {
  createSelector,
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {channelHasError} from '../../../../helpers/models/channelHelpers';
import {getUserParticipatingChannels} from '../../../../store/data/channels/channelsSelectors';
import {getCompanyPreferences} from '../../../../store/data/company/companySelectors';
import {getDismissedChannelErrors} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {getIsInboxVisible} from '../../../../store/data/workspace/workspaceSelectors';
import {ChannelErrorBanners} from './channelErrorBanners';

/*
 * Selectors.
 */

const getIsChannelAbuser = createSelector([getCompanyPreferences], (pref) => pref.isChannelAbuser);

const getErrorChannels = wrapInShallowSelector(
  createSelector(
    [getUserParticipatingChannels, getDismissedChannelErrors, getIsInboxVisible, getIsChannelAbuser],
    (channels, dismissedChannelErrors, isInboxVisible, isChannelAbuser) =>
      _(channels)
        .filter((c) => {
          // We need the channel to have an error.
          if (!channelHasError(c)) {
            return false;
          }

          if (isChannelAbuser) {
            return false;
          }

          // This error wasn't dismissed before.
          if (dismissedChannelErrors[c.id]) {
            return false;
          }

          // The inbox for this channel must be visible.
          return isInboxVisible(c.inboxId);
        })
        .sortBy((c) => c.id)
        .value(),
  ),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  errorChannels: getErrorChannels,
}));

export const ChannelErrorBannersContainer = connect(mapStateToProps)(ChannelErrorBanners);
